import { motion } from "framer-motion";
import { UsersRound, Landmark, ArrowUpRight } from "lucide-react";

const platforms = [
  {
    icon: UsersRound,
    tag: "Recursos Humanos",
    title: "Gestión de Talento Humano",
    description:
      "Administre planillas, procesos de reclutamiento, evaluaciones de desempeño y el desarrollo organizacional de su equipo desde una plataforma centralizada.",
    cta: "Entrar al Sistema de Recursos Humanos",
    href: "https://rrhh.grupoverticecr.com",
    testid: "platform-rrhh",
  },
  {
    icon: Landmark,
    tag: "Despacho Legal",
    title: "Servicios Legales y Notariales",
    description:
      "Genere documentos a partir de lógica de plantillas inteligentes, gestione comparecencias y dé seguimiento a cada proceso legal y notarial con total trazabilidad.",
    cta: "Entrar al Sistema de Despacho Legal",
    href: "https://legal.grupoverticecr.com",
    testid: "platform-legal",
  },
];

const fade = {
  hidden: { opacity: 0, y: 50 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.7, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] } }),
};

export const Plataformas = () => {
  return (
    <section id="plataformas" className="relative py-28 sm:py-36 bg-vnavy overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-vteal/10 rounded-full blur-[160px] pointer-events-none" />
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="max-w-3xl mb-16">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-vteal-light" />
            <span className="text-sm uppercase tracking-[0.3em] text-vteal-light font-semibold">Acceso a Sistemas</span>
          </div>
          <h2 className="font-serif text-4xl sm:text-5xl font-medium tracking-tight text-white leading-tight">
            Nuestras Plataformas Digitales
          </h2>
          <p className="mt-6 text-gray-400 leading-relaxed">
            Ingrese a los sistemas operativos de Grupo Vértice CR. Herramientas diseñadas para gestionar su talento humano y sus procesos legales con precisión.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {platforms.map((p, i) => {
            const Icon = p.icon;
            return (
              <motion.a
                key={p.tag}
                href={p.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={p.testid}
                custom={i}
                variants={fade}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: "-60px" }}
                className="relative rounded-2xl bg-vnavy-800 border border-vteal-light/25 p-8 sm:p-10 group overflow-hidden shadow-[0_0_25px_rgba(20,184,166,0.08)] hover:shadow-[0_0_45px_rgba(20,184,166,0.18)] transition-shadow duration-500 flex flex-col"
              >
                <span className="card-glow-line" />
                <div className="relative z-10 flex flex-col h-full">
                  <div className="flex items-center justify-between mb-8">
                    <div className="h-16 w-16 rounded-2xl bg-vteal/20 flex items-center justify-center">
                      <Icon className="h-8 w-8 text-vteal-light" />
                    </div>
                    <span className="text-[10px] uppercase tracking-[0.25em] text-vteal-light font-semibold border border-vteal-light/30 rounded-full px-4 py-1.5">
                      {p.tag}
                    </span>
                  </div>
                  <h3 className="font-serif text-3xl text-white mb-4">{p.title}</h3>
                  <p className="text-gray-400 leading-relaxed mb-10 flex-1">{p.description}</p>
                  <div className="flex items-center justify-between gap-4 rounded-xl bg-vteal-light px-6 py-4 text-vnavy font-semibold group-hover:bg-white transition-colors duration-300">
                    <span className="text-sm sm:text-base">{p.cta}</span>
                    <ArrowUpRight className="h-5 w-5 shrink-0 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-300" />
                  </div>
                </div>
              </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
};
